<ng-container *transloco="let t">
  <div class="page-wrap">
    <div class="d-flex flex-column">

      <!--      Mobile appbar-->
      <div class="mobile-header d-flex d-md-none px-0 px-lg-3 {{additionalClass}}">
        <div class="admin-logo logo--mobile">
          <img src="assets/img/svg/tracey-logo-white.svg" alt="Tracey logo"
            class="admin-logo-img admin-logo-img--mobile" (click)="onClickToLogoImage()">
          <div (click)="isMobileMenuActive = !isMobileMenuActive" class="logo__hamburger">
            <i [ngClass]="{'icon-change': isMobileMenuActive}" class="fas fa-bars"></i>
          </div>
        </div>
      </div>

      <!-- Page Header-->
      <section>
        <header class="page-header px-4">
          <div
            class="d-flex justify-content-center justify-content-md-between align-items-center h-100 flex-column flex-md-row">
            <div class="fw-bold pe-4 fs-3 page-title trim-text-second-line pt-3 pt-md-0">{{ pageTitle }}</div>
            <div class="d-flex align-items-center">
              <div ngbDropdown class="dark-text">
                <div class="circle" ngbDropdownToggle>
                  <i class="bi bi-bell"></i>
                  @if (unreadMessages?.length ?? 0 > 0) {
                  <div class="unread-msg-circle">
                    {{ unreadMessages?.length }}
                  </div>
                  }
                </div>
                <div ngbDropdownMenu aria-labelledby="languageDropdown" class="dropdown-menu">
                  <button ngbDropdownItem (click)="goToMessages(false)">
                    <span>
                      {{ 'app.common.unread' | transloco }}
                    </span>
                  </button>
                  <button ngbDropdownItem (click)="goToMessages(true)">
                    <span>
                      {{ 'app.common.read' | transloco }}
                    </span>
                  </button>
                </div>
              </div>
              <div class="page-header__separator"></div>
              <div class="circle me-2">
                @if(currentLoggedInOrganiser?.imageMedium){
                <img [src]="currentLoggedInOrganiser?.imageMedium">
                }@else {
                @if(currentLoggedInUser?.picture){
                <img [src]="currentLoggedInUser?.picture">
                }@else {
                <p class="font-family-primary fs-6">
                  {{currentLoggedInUser?.firstname?.charAt(
                  0)?.toUpperCase()}}{{currentLoggedInUser?.lastname?.charAt(
                  0)?.toUpperCase()}}
                </p>
                }
                }
              </div>
              <div class="d-flex flex-row">
                <p class="font-family-primary">{{
                  authenticationService.isOrganiser() ? currentLoggedInOrganiser?.name ??
                  t("app.common.tracey")
                  : t(
                  "app.common.tracey")
                  }}</p>
              </div>
              <div class="page-header__separator"></div>
              <div class="fw-bold font-family-primary">
                {{
                currentLoggedInUser?.firstname || currentLoggedInUser?.lastname
                ?
                ((currentLoggedInUser?.firstname ?? "") | titlecase) + " " + ((currentLoggedInUser?.lastname
                ?? "") | titlecase)
                :
                currentLoggedInUser?.email
                }}
              </div>
            </div>
          </div>
        </header>
      </section>
      <div class="d-flex flex-row">
        <!--      Sidebar menu-->
        <app-admin-menu [isMobileMenuActive]="isMobileMenuActive" (closeMobileMenu)="closeMobileMenu()" />
        <!--      Body-->
        <div class="body-container">
          <div class="container-fluid p-4 h-100">
            <router-outlet />
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
